import { Provider } from '@angular/core';

import { IrpfReadjustmentUseCasesImpl } from '@app/domain/use-cases/ptrab/irpf-readjustment/irpf-readjustment.use-cases';
import { IRPF_READJUSTMENT_USE_CASES } from '@app/domain/use-cases/ptrab/irpf-readjustment/irpf-readjustment.use-cases.contract';

export const irpfReadjustmentUseCasesProvider: Provider = {
  provide: IRPF_READJUSTMENT_USE_CASES,
  useClass: IrpfReadjustmentUseCasesImpl
};
